import React from "react";
import "./systemPerformance.css";

import SideNav from "../Components/sideNav";
import Navbar from "../Components/navbar";
import StatCards from "../Components/statCards";
import BigMultiBar from "./bigMultiBar";
import DonutChartBig from "./donutChartBig";
import CustomerTable from "./customerTable";

const SystemPerformance = () => {

  const statCardData = [
    {
      body: "12000",
      head: "Admin Logins",
      icon: "./images/PvxDashboard/StatCard/Dollar.svg",
    },
    {
      body: "2000",
      head: "Designers Login",
      icon: "./images/PvxDashboard/StatCard/Wallet.svg",
    },
    {
      body: "3000",
      head: "Total Projects",
      icon: "./images/PvxDashboard/StatCard/Discount.svg",
    },
    {
      body: "1000",
      head: "Incomplete Projects",
      icon: "./images/PvxDashboard/StatCard/Kpis.svg",
    },
    {
      body: "4000",
      head: "Avg Simulation",
      icon: "./images/PvxDashboard/StatCard/Subs.svg",
    },
  ];

  return (
    <div className="pvxSystemSupportColor">
      <Navbar />
      <SideNav active="Performance" />
      <div className="pvxSystemSupport">
        <StatCards statCardData={statCardData} />
        <div className="b2">
          <BigMultiBar title="Average Simulations Completed" dropdown={true} />
          <DonutChartBig title="Projects" />
        </div>
        <div className="b2">
          <CustomerTable title="Project Details" />
        </div>
      </div>
    </div>
  );
};

export default SystemPerformance;
